import request from '@apps-common/js-client/api/request';

import {BLOBZ_API_URL} from '../config.js';

export const fetchFromBlobz = id =>
  request({url: `${BLOBZ_API_URL}/${id}`, method: 'GET'});

export const saveToBlobz = (state, sessionId = '') =>
  request({
    url: `${BLOBZ_API_URL}${sessionId ? '/' + sessionId : ''}`,
    method: sessionId ? 'PUT' : 'POST',
    data: state,
  });
